export function fetchResponseHelper(res) {
  if (res.status === 200) {
    return res.json();
  }

  if (res.status >= 400 && res.status < 500) {
    return new Promise((_resolve, reject) => {
      res.json().then(data => {
        reject({ message: data.error });
      });
    });
  } else {
    throw new Error(`Response code ${res.status}`);
  }
}

export function fetchErrorHelper(error) {
  throw error;
}


// WEBPACK FOOTER //
// ./src/lib/api.js